export const pipe =
  (...fns) =>
  (x) =>
    fns.reduce((val, fn) => fn(val), x);

export const filter = (fn) => (arr) => arr.filter(fn);
export const find = (fn) => (arr) => arr.find(fn);
export const map = (fn) => (arr) => arr.map(fn);
export const reduce = (fn, initialValue) => (arr) => arr.reduce(fn, initialValue);
